var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedWhiteLightGreenBgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#1DC98F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3357 2.70104C9.4975 2.91236 9.41477 3.06922 9.3357 3.16899L5.18778 8.49327C5.14821 8.5432 4.86688 8.57153 4.80902 8.57153C4.75116 8.57153 4.69588 8.5432 4.65631 8.49327L2.69387 6.0171C2.53059 5.80327 2.53063 5.56691 2.69377 5.45084C2.83505 5.29678 3.13955 5.26302 3.2462 5.33L4.96638 7.42404L8.72675 2.62873C8.92457 2.56175 9.19713 2.52005 9.3357 2.70104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedWhiteLightGreenBgRounded);
export default __webpack_public_path__ + "static/media/checkedWhiteLightGreenBgRounded.67f2910f350d8b3411ff2617c3ca350e.svg";
export { ForwardRef as ReactComponent };